module.exports = __webpack_public_path__ + "img/02.44dcf343.png";